import { rootElement } from "./components/shared";

export const getLocalApplicationMetadata = () => {
    const environment = rootElement.attributes.getNamedItem("app_env")?.value;
    const version = rootElement.attributes.getNamedItem("app_version")?.value;

    return { environment, version };
};
